import { Box, Typography } from "@mui/material";

const MovieColabWarnings = ({ warningText }) => {
  return (
    <Box
      sx={{
        margin: "8px 0px",
        px: "12px",
        py: "8px",
        width: "100%",
        backgroundColor: "rgba(239, 58, 58, 0.3)",
        border: "1px solid #EF3A3A",
        borderRadius: "5px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: 400,
          color: "#F9F9F9",
          flex: 1,
        }}
      >
        {warningText}
      </Typography>
    </Box>
  );
};

export default MovieColabWarnings;
